import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {redirectHomeRefreshPaths} from './app-routes'
import {config} from '../config'

export function AppRedirectHandler() {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (redirectHomeRefreshPaths.some(path => decodeURIComponent(location.pathname).endsWith(path))) {
            const rootState = `/${config.app.rootState}`
            navigate(location.pathname === rootState || location.pathname.startsWith(`${rootState}/`) ? rootState : "/", { replace: true });
        }
    }, [location.pathname, navigate]);
}
